const toAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
};

const parseApiDate = (value) => {
  const [year, month, day] = String(value || "").split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day, 12);
};

export const buildSaldoReport = ({
  dateFrom,
  dateTo,
  departmentId,
  groupId,
  employeeId,
  departmentLabel,
  groupLabel,
  employeeLabel,
  response,
}) => {
  const rows = (response?.items || [])
    .map((item) => ({
      id: item.user_id,
      name: item.full_name || "Без имени",
      opening: toAmount(item.saldo_start),
      accrued: toAmount(item.total_salary),
      paid: toAmount(item.paid),
      closing: toAmount(item.saldo_end),
    }))
    .sort((left, right) => left.name.localeCompare(right.name, "ru"));

  const summed = rows.reduce(
    (acc, row) => ({
      opening: acc.opening + row.opening,
      accrued: acc.accrued + row.accrued,
      paid: acc.paid + row.paid,
      closing: acc.closing + row.closing,
    }),
    { opening: 0, accrued: 0, paid: 0, closing: 0 }
  );
  const apiTotals = response?.totals;
  const totals = apiTotals
    ? {
        opening: toAmount(apiTotals.saldo_start),
        accrued: toAmount(apiTotals.total_salary),
        paid: toAmount(apiTotals.paid),
        closing: toAmount(apiTotals.saldo_end),
      }
    : summed;

  return {
    dateFrom: parseApiDate(response?.date_from) || dateFrom,
    dateTo: parseApiDate(response?.date_to) || dateTo,
    departmentId,
    groupId,
    employeeId,
    departmentLabel,
    groupLabel,
    employeeLabel,
    paymentsSource: response?.payments_source || null,
    rows,
    totals,
    generatedAt: new Date(),
  };
};
